import { FC } from 'react';
import { ButtonProps } from '@material-ui/core/Button';

import {
  PlanButton as UIPlanButton,
  KIDButton as UIKIDButton,
  DownloadButton as UIDownloadButton,
  RegisterButton as UIRegisterButton,
} from './Buttons.styles';

export const PlanButton: FC<ButtonProps> = (props) => (
  <UIPlanButton {...props} variant="contained">
    Plan & Specifications
  </UIPlanButton>
);

export const KIDButton: FC<ButtonProps> = (props) => (
  <UIKIDButton {...props} variant="contained">
    {props.name}
  </UIKIDButton>
);

export const DownloadButton: FC<ButtonProps> = (props) => (
  <UIDownloadButton {...props} variant="contained">
    Download
  </UIDownloadButton>
);

export const RegisterButton: FC<ButtonProps> = (props) => (
  <UIRegisterButton {...props} variant="contained" color="primary">
    Register Interest
  </UIRegisterButton>
);
